import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { LURAH } from "@/lib/kop";
import { useAuth } from "@/context/AuthContext";

const DEFAULT = { ...LURAH, distrik_nama: "", distrik_nip: "" };
const Ctx = createContext({ pejabat: DEFAULT, setPejabat: () => {} });

export const PejabatProvider = ({ children }) => {
  const { user } = useAuth();
  const [pejabat, setPejabat] = useState(DEFAULT);
  const reload = useCallback(() => {
    api.get("/settings/pejabat").then((r) => setPejabat(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    if (user) reload();
  }, [user, reload]);
  return <Ctx.Provider value={{ pejabat, setPejabat }}>{children}</Ctx.Provider>;
};

export const usePejabat = () => useContext(Ctx);
